import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "./../images/logooooo-removebg-preview-removebg-preview.png";
import { FaBarsStaggered } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import Shrikrishna from "../images/Radha Krishna Holi.jpeg";
// import About from "../images/about.jpeg";
// import contactus from "../images/contactus.jpeg";
import temple from "../images/temple.jpeg";
// import blog from "../images/blog.jpeg";
import Home from "./../images/home.png";
import Blog from "./../images/blog.png";
import Temple from "./../images/temples.png";
import donate from "./../images/donate.png";
import aboutus from "./../images/aboutus.png";
import contact from "./../images/contact.png";
import dharmikicon from "./../images/templee.png";

import "../styles/header.css";
// import { click } from "@testing-library/user-event/dist/click";

const Header = () => {
  const [activeItem, setActiveItem] = useState(null);
  

  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const handleClose = ()=>{
    const closeBtn = document.getElementById("close-btn");
    if (closeBtn) {
      closeBtn.checked = true;
    }
  }

  return (
    <>
      <nav>
        <div className="wrapper">
          <div className="logo">
            <Link to="/">
              <img style={{ width: "95px" }} src={Logo} alt="" />
            </Link>
          </div>
          <input type="radio" name="slider" id="menu-btn" />
          <input type="radio" name="slider" id="close-btn" />
          <ul className="nav-links">
            <label for="close-btn" className="btn close-btn headermenu">
              <FaTimes />
            </label>
            <li
              className={activeItem === 0 ? "active" : ""}
              onClick={() => {handleItemClick(0);handleClose();}}
            >
              <NavLink to="/">
                <img src={Home} alt="" />
                Home
              </NavLink>
            </li>

            <li
              className={activeItem === 0 ? "active" : ""}
              onClick={() => {handleItemClick(1);handleClose();}}
            >
              <NavLink to="/blog">
                <img src={Blog} alt="" /> Blogs
              </NavLink>
              {/* <input type="checkbox" id="showMega" />
              <label for="showMega" className="mobile-item headermenu">
                Blogs
              </label> */}
              {/* <div className="mega-box">
                <div className="content">
                  {/* <div className="rowww">
                    <img src={blog} alt="" />
                  </div> */}

              {/* <div className="rowww">
                    <header>Blogs</header>
                    <ul className="mega-links">
                      <li>
                        <Link to="#">Blog detail 1>
                      </li>
                      <li>
                        <Link to="#">Blog detail 2>
                      </li>
                      <li>
                        <Link to="#">Blog detail 3>
                      </li>
                      <li>
                        <Link to="#">Blog detail 4>
                      </li>
                    </ul>
                  </div> */}
              {/* </div>
              </div> */}
            </li>

            <li
              className={activeItem === 0 ? "active" : ""}
              onClick={() => handleItemClick(2)}
            >
              <NavLink to="whats-inside" className="desktop-item">
                <img src={Temple} alt="" /> Temple
              </NavLink>
              <input type="checkbox" id="showMega1" />
              <label for="showMega1" className="mobile-item headermenu">
                <img src={Temple} alt="" /> Temple
              </label>
              <div className="mega-box">
                <div className="content">
                  <div className="rowww">
                    <img src={temple} alt="" />
                  </div>

                  <div className="rowww">
                    <header>Temple</header>
                    <ul className="mega-links">
                      <li>
                        <Link to="/whats-inside" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          What is inside?
                        </Link>
                      </li>
                      <li>
                        <Link to="/activities"  onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Activities
                        </Link>
                      </li>
                      <li>
                        <Link to="/events"  onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Events
                        </Link>
                      </li>
                      <li>
                        <Link to="/timing"  onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Timing
                        </Link>
                      </li>
                      <li>
                        <Link to="/vaishnava-calender"  onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Vaishnava Calendar
                        </Link>
                      </li>
                      <li>
                        <Link to="/fcra-report" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          FCRA Reports
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>

            <li
              className={activeItem === 0 ? "active" : ""}
              onClick={() => handleItemClick(5)}
            >
              <NavLink to="/donate-temple-construction-seva" className="desktop-item">
                <img src={donate} alt="" /> Donate Now
              </NavLink>
              <input type="checkbox" id="showMega4" />
              <label for="showMega4" className="mobile-item headermenu">
                <img src={donate} alt="" /> Donate Now
              </label>
              <div className="mega-box">
                <div className="content">
                  <div className="rowww">
                    <img src={Shrikrishna} alt="" />
                  </div>

                  <div className="rowww">
                    <header>Donate Now</header>
                    <ul className="mega-links">
                     <li>
                        <Link to="https://razorpay.me/@iskcon2332" onClick={handleClose}>
                          {" "}
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Ratha Yatra Prasad Donation
                        </Link>
                      </li>
                      <li>
                        <Link to="https://razorpay.me/@iskcon2332" onClick={handleClose}>
                          {" "}
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Quick Donate
                        </Link>
                      </li>
                      <li>
                        <Link to="/donate-temple-construction-seva" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Temple Construction Seva
                        </Link>
                      </li>
                      <li>
                        <Link to="/donate-shastra" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Gita Daan Seva
                        </Link>
                      </li>
                      <li>
                        <Link to="/donate-sadhu-bhojan-seva" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Sadhu Bhojan Seva
                        </Link>
                      </li>
                      <li>
                        <Link to="/donate-food-for-life" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Food Donation
                        </Link>
                      </li>
                      <li>
                        <Link to="/donate-deity-seva" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Deity Seva
                        </Link>
                      </li>
                      <li>
                        <Link to="/donate-gau-seva" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Gau Seva
                        </Link>
                      </li>
                      {/* <li>
                        <Link to="/sponsor-feast" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Feast Sponsorship Seva
                        </Link>
                      </li> */}
                      <li>
                        <Link to="/nitya-seva" onClick={handleClose}>
                          <img
                            src={dharmikicon}
                            className="dharmikicon"
                            alt=""
                          />{" "}
                          Nitya Sevak
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li
              className={activeItem === 0 ? "active" : ""}
              onClick={() => {handleItemClick(4);handleClose();}}
            >
              <NavLink to="/about-srila-prabhupada">
                <img src={aboutus} alt="" /> About Us
              </NavLink>
              {/* <input type="checkbox" id="showMega3" />
              <label for="showMega3" className="mobile-item headermenu">
                About Us
              </label> */}
              {/* <div className="mega-box">
                <div className="content">
                  <div className="rowww">
                    <img src={About} alt="" />
                  </div>

                  {/* <div className="rowww">
                    <header>About Us</header>
                    <ul className="mega-links">
                      <li>
                        <Link to="/about-srila-prabhupada">
                          About Srila Prabhupada
                        >
                      </li>
                      <li>
                        <Link to="/history-Of-ISKCON">History Of ISKCON>
                      </li>
                      <li>
                        <Link to="/our-philosophy">Our Philosophy>
                      </li>
                      <li>
                        <Link to="/Best-way-to-do-charity">
                          Best way to do charity
                        >
                      </li>
                      <li>
                        <Link to="/hare-krishna-movement">
                          Hare Krishna Movement
                        >
                      </li>
                      <li>
                        <Link to="/gopal-krishna-goswami">
                          Gopal Krishna Goswami
                        >
                      </li>
                      <li>
                        <Link to="/ask-questions-ISKCON">Ask questions ISKCON>
                      </li>
                    </ul>
                  </div> */}
              {/* </div>
              </div> */}
            </li>
            <li
              className={activeItem === 0 ? "active" : ""}
              onClick={() => {handleItemClick(3);handleClose();}}
            >
              <NavLink to="get-connect-locally">
                <img src={contact} alt="" /> Contact us
              </NavLink>
              {/* <input type="checkbox" id="showMega2" />
              <label for="showMega2" className="mobile-item headermenu">
                Contact us
              </label> */}
              {/* <div className="mega-box">
                <div className="content">
                  <div className="rowww">
                    <img src={contactus} alt="" />
                  </div> */}

              {/* <div className="rowww">
                    <header>Contact us</header>
                    <ul className="mega-links">
                      <li>
                        <Link to="/get-connect-locally">GET CONNECTED LOCALLY</Link>
                      </li>
                      <li>
                        <Link to="/connect-us-online">CONNECT ONLINE</Link>
                      </li>
                      <li>
                        <Link to="/how-to-reach">HOW TO REACH</Link>
                      </li>
                      <li>
                        <Link to="#">CALENDAR</Link>
                      </li>
                      <li>
                        <Link to="/get-email-update">GET EMAIL UPDATES</Link>
                      </li>
                      <li>
                        <Link to="/download-wallpaper-calender">
                          DOWNLOAD WALLPAPER
                        </Link>
                      </li>
                      <li>
                        <Link to="/download-app">DOWNLOAD APP (ANDROID)</Link>
                      </li>
                    </ul>
                  </div> */}
              {/* </div>
              </div> */}
            </li>
          </ul>
          <label for="menu-btn" className="btn headermenu menu-btn" >
            <FaBarsStaggered />
          </label>
        </div>
      </nav>
    </>
  );
};

export default Header;
